import { Link } from "react-router";
import { Mail, Briefcase, List, Send } from "lucide-react";
import { Button } from "@nosible/shared/components/ui/button";

export function AdminEmailsHome() {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-silica font-display flex items-center gap-2">
          <Mail className="h-6 w-6" />
          Email Management
        </h1>
        <p className="text-chromium-mist mt-1">
          Manage custom emails, view email history, and track email campaigns.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Send Custom Email */}
        <Link to="/emails/custom">
          <div className="bg-slate-core rounded-lg p-6 hover:bg-slate-core/80 transition-colors cursor-pointer group h-full">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 rounded-lg bg-neon-green/20 group-hover:bg-neon-green/30 transition-colors">
                <Send className="h-6 w-6 text-neon-green" />
              </div>
              <h2 className="text-lg font-semibold text-silica">Send Custom Email</h2>
            </div>
            <p className="text-sm text-chromium-mist">
              Create and send custom emails to users based on their email preferences.
            </p>
          </div>
        </Link>

        {/* View All Emails */}
        <Link to="/emails/list">
          <div className="bg-slate-core rounded-lg p-6 hover:bg-slate-core/80 transition-colors cursor-pointer group h-full">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 rounded-lg bg-signal-blue/20 group-hover:bg-signal-blue/30 transition-colors">
                <List className="h-6 w-6 text-signal-blue" />
              </div>
              <h2 className="text-lg font-semibold text-silica">All Emails</h2>
            </div>
            <p className="text-sm text-chromium-mist">
              View complete email history including authentication, invitations, and custom emails.
            </p>
          </div>
        </Link>

        {/* View Email Jobs */}
        <Link to="/emails/jobs">
          <div className="bg-slate-core rounded-lg p-6 hover:bg-slate-core/80 transition-colors cursor-pointer group h-full">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-3 rounded-lg bg-violet-pulse/20 group-hover:bg-violet-pulse/30 transition-colors">
                <Briefcase className="h-6 w-6 text-violet-pulse" />
              </div>
              <h2 className="text-lg font-semibold text-silica">Email Jobs</h2>
            </div>
            <p className="text-sm text-chromium-mist">
              Track email campaigns and bulk sends with detailed statistics and status.
            </p>
          </div>
        </Link>
      </div>


    </div>
  );
}
